export const USE_RETRIEVE_TEAM = "useRetrieveTeam";
export const USE_RETRIEVE_TEAM_FEED = "useRetrieveTeamFeed";
export const USE_RETRIEVE_PLAYER_FEED = "useRetrievePlayerFeed";
export const USE_RETRIEVE_TEAMS_BY_PLAYER_ID = "useRetrieveTeamsByPlayerId";
export const USE_LIST_PLAYERS_BY_TEAM_ID = "useListPlayersByTeamId";
export const USE_RETRIEVE_INTRA_SQUAD_MATCH = "useRetrieveIntraSquadMatch";
export const USE_RETRIEVE_ADDABLE_TEAMS = "useRetrieveAddableTeams";
export const USE_RETRIEVE_DIVISION = "useRetrieveDivision";
export const USE_RETRIEVE_DIVISIONS_BY_SEASON_ID = "useRetrieveDivisionsBySeasonId";
